const translations = {
  "support":                  "Support",
  "support.contact":          "Contact",
  "support.faq":              "F.A.Q",
  "support.privacy":          "Privacy",
  "support.privacy.policy":   "Privacy Policy",
  "support.terms":            "Terms of Use",
}

export default translations;